import { useState } from "react";

import { CONVERSATION_LIMIT_REACHED, toAssistantErrorCode } from "./assistantErrorCode";
import type {
  AssistantChatAdapter,
  AssistantChatControls,
  AssistantChatState,
  AssistantConversationQuery,
} from "./types";

export type ConversationRestoreView = "loading" | "limit" | "failed" | "chat";

type UseConversation = AssistantChatAdapter<AssistantChatState, AssistantChatControls>["useConversation"];

export const useConversationRestore = (useConversation: UseConversation, aiSessionId: string | null) => {
  const [hasRestored, setHasRestored] = useState(false);
  const conversation = useConversation(aiSessionId, { enabled: !hasRestored });
  if (!hasRestored && conversation.isFetchedAfterMount && conversation.isSuccess) {
    setHasRestored(true);
  }
  return { conversation, view: getRestoreView(aiSessionId, hasRestored, conversation) };
};

const getRestoreView = (
  aiSessionId: string | null,
  hasRestored: boolean,
  conversation: AssistantConversationQuery
): ConversationRestoreView => {
  if (!aiSessionId || hasRestored) {
    return "chat";
  }
  if (conversation.isPending || conversation.isFetching) {
    return "loading";
  }
  if (conversation.isError && toAssistantErrorCode(conversation.error) === CONVERSATION_LIMIT_REACHED) {
    return "limit";
  }
  return conversation.isError || !conversation.data ? "failed" : "chat";
};
